'use client'

import { PropsWithChildren } from 'react'
import { FiltersContextProvider } from './FiltersContextProvider'

type AccreditedEstablishmentsProviderProps = PropsWithChildren<{
  initialParams?: Record<string, string>
}>

const AccreditedEstablishmentsProvider = ({
  initialParams,
  children
}: AccreditedEstablishmentsProviderProps) => {
  return (
    <FiltersContextProvider initialParams={initialParams}>
      {children}
    </FiltersContextProvider>
  )
}

export { AccreditedEstablishmentsProvider }
